export default "__VITE_ASSET__b9cf19d1__"